import React, {
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import {
  API_URL
} from "./config";

import "bootstrap/dist/css/bootstrap.min.css";

function VerifyEmailOtp() {

  const navigate =
    useNavigate();

  const [otp, setOtp] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const email =
    localStorage.getItem(
      "verifyEmail"
    );

  // ==========================
  // VERIFY OTP
  // ==========================
  const handleVerify =
    async (e) => {

      e.preventDefault();

      setError("");

      if (!otp) {
        return setError(
          "Please enter OTP"
        );
      }

      try {

        setLoading(true);

        const res =
          await fetch(
            `${API_URL}/api/verify-email-otp`,
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({
                email,
                otp,
              }),
            }
          );

        const data =
          await res.json();

        if (res.ok) {

          alert(
            "✅ Email verified successfully"
          );

          localStorage.removeItem(
            "verifyEmail"
          );

          localStorage.removeItem(
            "verifyUserId"
          );

          navigate(
            "/login"
          );

        } else {

          setError(
            data.error ||
              "OTP verification failed"
          );
        }

      } catch (err) {

        console.error(err);

        setError(
          "Network error"
        );

      } finally {

        setLoading(false);
      }
    };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100 bg-light">

      <form
        onSubmit={
          handleVerify
        }
        className="bg-white p-4 rounded shadow w-100"
        style={{
          maxWidth:
            "450px",
        }}
      >

        <h2 className="text-center mb-4">
          Verify Email OTP
        </h2>

        <p className="text-center text-muted">
          OTP sent to:
          <br />
          <strong>
            {email}
          </strong>
        </p>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        <div className="mb-3">

          <label className="form-label">
            Enter OTP
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) =>
              setOtp(
                e.target.value
              )
            }
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={
            loading
          }
        >
          {loading
            ? "Verifying..."
            : "Verify OTP"}
        </button>
      </form>
    </div>
  );
}

export default VerifyEmailOtp;